export default __webpack_public_path__ + "static/media/loja.7a25b69f.jpg";